const messages = {
  //category
  "affiliation.info.title": "عنوان",
  "affiliation.info.webLink": "وب‌سایت",
  "affiliation.info.email": "آدرس ایمیل",
  "affiliation.info.branch": "گروه بندی",
  "affiliation.info.webLinkShort": "لینک کوتاه",
  "affiliation.info.address": "آدرس ",
  "affiliation.info.googleMap": "موقعیت در نقشه گوگل",
  "affiliation.info.province": "استان",
  "affiliation.info.RankId0": "مرتبه علمی",
  "affiliation.info.keyCode": "شناسه یکتا",
  "affiliation.query.sciVal": " SciVal Keys",
  "affiliation.query.scopusId": " Scopus Id",
  "affiliation.query.scopusQuery": "Scopus Affiliation Query",
  "affiliation.query.wosId": "شناسه WoS",
  "affiliation.query.wosQuery": "کوئری WoS",
  "affiliation.query.scopusTitles": "کوئری اسکوپوس",

  "affiliation.l10n.name.fa": "نام",
  "affiliation.l10n.nameShort.fa": "نام اختصاری",
  "affiliation.l10n.abbrText.fa": "کد اختصاری",
  "affiliation.l10n.subjectAreas.fa": "برچسب‌های موضوعی",
  "affiliation.l10n.introText.fa": "معرفی",

  "affiliation.l10n.name.en": "Name",
  "affiliation.l10n.nameShort.en": "Short name",
  "affiliation.l10n.abbrText.en": "Abbreviation code",
  "affiliation.l10n.subjectAreas.en": "Subject tags",
  "affiliation.l10n.introText.en": "Introduction",
};

export default messages;
